import { action } from "@ember/object"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type { Course, CourseDateAnnotationSingle } from "@shared/models/course"
import type { CourseDateCombined } from "@shared/models/course-date-combined"
import styles from "./course-date-annotation.module.css"

interface Args {
  course: Course
  courseDate: CourseDateCombined
  annotation: CourseDateAnnotationSingle
  location?: string
}

export default class CourseDateAnnotationComponent extends Component<Args> {
  readonly styles = styles

  @tracked menuIsOpen = false

  @action toggleMenu() {
    this.menuIsOpen = !this.menuIsOpen
  }
}
